import { Injectable } from '@angular/core';
import { AbstractControlOptions, FormArray, Validators } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import {
  Parameters,
  PledgeProductRead,
} from '@app/forms/subscription/definition/interface/Pledge';
import { FormConfig } from '@app/forms/subscription/definition/types/subscription';
import FormGroupArray from '@app/forms/subscription/services/FormGroupArray';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(entity: PledgeProductRead & { parameters: any }, option) {
    const parameters: Parameters = {
      ...option,
    };
    let options: AbstractControlOptions = {};

    const formConfig: FormConfig<PledgeProductRead & { parameters: any }> = {
      id: [entity.id],
      type: [entity.type],
      productId: [entity.productId],
      productName: [entity.productName],
      status: [entity.status],
      parameters: this.formBuilder.group({
        ittMontantMensuel: [
          entity?.parameters?.ittMontantMensuel || null,
        ],
        ittFraisGenerauxMensuels: [
          entity?.parameters?.ittFraisGenerauxMensuels || null,
        ],
        ittFranchises: [
          entity?.parameters?.ittFranchises || null,
        ],
        ittRenfortDos: [
          !_.isNil(entity?.parameters?.ittRenfortDos)
            ? entity?.parameters?.ittRenfortDos
            : null,
        ],
        ittAffectionPsy: [
          !_.isNil(entity?.parameters?.ittAffectionPsy)
            ? entity?.parameters?.ittAffectionPsy
            : null,
        ],
        ittDelaisAttente: [
          entity?.parameters?.ittDelaisAttente || null,
        ],
        ittMiTempsTherapeutique: [
          !_.isNil(entity?.parameters?.ittMiTempsTherapeutique)
            ? entity?.parameters?.ittMiTempsTherapeutique
            : null,
        ],
        invaliditeMontantMensuel: [
          entity?.parameters?.invaliditeMontantMensuel || null,
        ],
        invaliditeBareme: [
          entity?.parameters?.invaliditeBareme || null,
        ],
        invaliditeSeuilDeclenchement: [
          entity?.parameters?.invaliditeSeuilDeclenchement || null,
        ],
        decesPtiaMontant: [
          entity?.parameters?.decesPtiaMontant || null,
        ],
        cotisationMensuelle: [
          entity?.parameters?.cotisationMensuelle || null,
        ],
        cotisationMadelin: [
          entity?.parameters?.cotisationMadelin || null,
        ],
        commentaire: [
          entity?.parameters?.commentaire || null,
        ],
      }),
    };

    return this.formBuilder.group(formConfig, options);
  }
  generate(entity: any, option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
      propertyName: 'products',
    });
  }

  get products() {
    return this.form.get('products') as FormArray;
  }

  extract() {
    return this.form.value.products;
  }
}
